import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import posthog from "posthog-js";
import mutationFn from "ApiLayer/Equipment/submitEquipmentSurvey";
import { EquipmentSurveyInput } from "gql/graphql";
import { showMutationAlert } from "utils/helpers";
import useAlert from "hooks/useAlert";
import { useResetRecommendedBMCRPQueries } from "hooks/useResetRecommendedBMCRPQueries";

export const useSubmitEquipmentData = (buildingModelUid: string, onSuccess: () => void, onError: () => void) => {
    const accessToken = useAccessToken();
    const alert = useAlert();
    const navigate = useNavigate();
    const resetRecommendedBMCRPQueries = useResetRecommendedBMCRPQueries(buildingModelUid);

    return useMutation({
        mutationFn: async (equipmentData: EquipmentSurveyInput) =>
            mutationFn(accessToken, buildingModelUid, equipmentData),
        onSuccess: () => {
            onSuccess();
            navigate(`/buildings/${buildingModelUid}`);
            posthog.capture("Update-equipment success");
            alert.success("Equipment information updated.");
            resetRecommendedBMCRPQueries();
        },
        onError: (errors) => {
            onError();
            showMutationAlert(errors, alert);
            posthog.capture("Add-equipment success");
        },
    });
};
